import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import get from 'lodash/get'
import * as preferences from '../../globals/tracking/preferences'
import none from './none'
import normal from './normal'
import explicit from './explicit'
import { loadAnalytics } from '../../globals/load-analytics'
import { trackCookies } from '../../globals/tracking/track-handler'

const layoutMap = {
  none,
  normal,
  explicit,
}

class CookieMapper extends React.PureComponent {
  constructor(props) {
    super(props)

    const { data } = props
    this.language = get(data, 'campaignData.cookieOverlay.language', 'de')
    this.layout = get(data, 'campaignData.cookieOverlay.layout', 'none')
    this.campaignId = get(data, 'campaignData._id')

    this.state = { display: false }
  }

  get storedIntegrations() {
    return preferences.getPreferences(this.campaignId)
  }

  get defaultIntegration() {
    const { data } = this.props
    const integrations = JSON.parse(data.integrationData.services)

    const displayNames = Object.keys(integrations)

    const integrationMap = {}
    displayNames.forEach((displayName) => {
      integrationMap[displayName] = true
    })

    return integrationMap
  }

  componentDidMount() {
    const { display } = this.props

    if (display === false) {
      return this.setState({ display: false })
    }

    if (this.layout === 'normal') {
      return this.setState({ display: true })
    }

    if (typeof window !== 'undefined' && !display) {
      if (preferences.exists(this.campaignId)) {
        this.setState({ display: false })

        this.loadAnalytics(this.storedIntegrations)
      } else {
        this.setState({ display: true })
      }
    } else {
      this.setState({ display: true })
    }
  }

  adjustIntegrations(selectedIntegrations) {
    const { data } = this.props
    const integrations = JSON.parse(data.integrationData.services)

    const activeIntegrations = {}
    Object.keys(selectedIntegrations).forEach((displayName) => {
      const enabled = selectedIntegrations[displayName]

      if (enabled) {
        activeIntegrations[displayName] = integrations[displayName]
      }
    })

    return activeIntegrations
  }

  loadAnalytics = (selectedIntegrations) => {
    const { data, onAcceptClick } = this.props
    if (!selectedIntegrations) {
      selectedIntegrations = this.defaultIntegration
    }

    const companyId = data.campaignData.companyId

    const activeIntegrations = this.adjustIntegrations(selectedIntegrations)

    // Reload app when something was disabled
    if (this.storedIntegrations) {
      Object.keys(this.storedIntegrations).forEach((integration) => {
        if (this.storedIntegrations[integration] && !activeIntegrations[integration]) {
          window.location.href = window.location.href.replace('/cookie-policy', '')
        }
      })
    }

    loadAnalytics(companyId, activeIntegrations)

    if (this.layout !== 'normal') this.setState({ display: false })

    preferences.setPreferences(this.campaignId, selectedIntegrations)
    trackCookies(Object.keys(activeIntegrations))

    if (onAcceptClick) onAcceptClick()
  }

  render() {
    const { data, display, disableCookiePoliciesLink } = this.props
    if (!this.state.display && !display) {
      return null
    }

    const integrations = Object.keys(JSON.parse(data.integrationData.services))

    const CookieBanner = layoutMap[this.layout]

    // second condition prevents cookie overlay from showing in SSR
    // prevents flickering
    if (CookieBanner && typeof window !== `undefined`) {
      return (
        <CookieBanner
          campaignId={this.campaignId}
          language={this.language}
          integrations={integrations}
          storedIntegrations={this.storedIntegrations}
          loadAnalytics={this.loadAnalytics}
          disableCookiePoliciesLink={disableCookiePoliciesLink}
        />
      )
    }

    return null
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          companyId
          cookieOverlay {
            layout
            language
          }
        }
        integrationData {
          services
        }
      }
    `}
    render={(data) => <CookieMapper data={data} {...props} />}
  />
)
